import { render, staticRenderFns } from "./OptionsQuestion.vue?vue&type=template&id=70cd935e&scoped=true&"
import script from "./OptionsQuestion.vue?vue&type=script&lang=js&"
export * from "./OptionsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./OptionsQuestion.vue?vue&type=style&index=0&id=70cd935e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd935e",
  null
  
)

export default component.exports